import { type UserDetails } from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

export const authApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    whoAmI: builder.query<UserDetails, void>({
      query: () => {
        const params = new URLSearchParams(window.location.search)
        const station = params.get('unitHandlingStation')!
        const dpiVersion = params.get('dpiVersion') ?? '300'
        const queryParams = `?unitHandlingStation=${encodeURIComponent(station)}&dpiVersion=${encodeURIComponent(dpiVersion)}`

        return {
          url: `authenticate/whoami${queryParams}`,
          method: 'GET'
        }
      }
    }),
    logout: builder.mutation<void, void>({
      query: () => {
        return {
          url: 'authenticate/logout',
          method: 'POST'
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useWhoAmIQuery, useLogoutMutation } = authApi
